import { inject, Injectable, signal } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogConfig } from '../interfaces/mat.interface';
import { firstValueFrom } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class MatDialogService {
  private _dialog = inject(MatDialog);
  
  private _currentDialogRef = signal<MatDialogRef<unknown> | null>(null);
  public currentDialogRef = this._currentDialogRef.asReadonly();

  async openMatDialog<T, D>(args: DialogConfig<T, D>): Promise<MatDialogRef<T>> {
    if (this._currentDialogRef()) {
      this._currentDialogRef().close();
      await firstValueFrom(this._currentDialogRef().afterClosed());
    }

    const ref = this._dialog.open(args.component, {
      data: args.data ?? null,
      panelClass: args.panelClass ?? [],
      backdropClass: args.backdropClass ?? [],
      enterAnimationDuration: args.enterAnimationDuration ?? '0ms',
      exitAnimationDuration: args.exitAnimationDuration ?? '150ms',
    });

    this._currentDialogRef.set(ref as MatDialogRef<unknown>);
    
    ref.afterClosed().subscribe(() => {
      this._currentDialogRef.set(null);
    });
    
    return ref;
  }

  closeMatDialog<T>(matDialogRef: MatDialogRef<T>): void {
    matDialogRef?.close();
  }

  closeAllMatDialogs(): void {
    this._dialog?.closeAll();
  }
}
